// ConfirmationModal.js - Updated with configurable button color
import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Text,
} from '@chakra-ui/react';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm", 
    message,
    confirmButtonText = "Confirm",
    confirmButtonColorScheme = "green" // New prop with default
}) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontFamily="Inter" fontWeight="600">
                    {title}
                </ModalHeader>
                <ModalBody>
                    <Text fontFamily="Inter">
                        {message}
                    </Text>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" mr={3} onClick={onClose} fontFamily="Inter">
                        Cancel
                    </Button>
                    <Button 
                        colorScheme={confirmButtonColorScheme} 
                        onClick={onConfirm} 
                        fontFamily="Inter"
                    >
                        {confirmButtonText}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ConfirmationModal;